import controller from './password-reset.controller';
import template from './password-reset.pug';

const PasswordResetComponent = {
  template,
  controller,
};

export default PasswordResetComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/password-reset/password-reset.component.js